// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getFulfillmentOrderAuditEvents } from '@/audit/api/get-fulfillment-order-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { Stack, Typography } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  fulfillmentKey: string;
}

/**
 * Suspends while fetching the audit events for a single fulfillment order and
 * renders them in reverse chronological order using the shared
 * AuditEventListItem.
 */
export function FulfillmentAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['fulfillment', props.fulfillmentKey, 'audit'],
    queryFn: () => getFulfillmentOrderAuditEvents(props.fulfillmentKey),
    retry: false,
  });

  if (data.events.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No audit events recorded for this fulfillment order yet
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
